import { Grid, Typography } from '@mui/material';
import { FC, useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { FormButton } from 'thermia-react-container';
import TableSkeleton from '../../../components/table/skeleton';
import { RegistrationsContext } from '../../../context/contextProvider';
import UnregisteredDevicesTable from '../components/unregisteredDevicesTable';

interface Props {
  isLoading: boolean;
}

const Wrapper: FC<Props> = ({ isLoading }) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [selectedDevices, setSelectedDevices] = useState<string[]>([]);
  const { t } = useTranslation('registrations');
  const navigate = useNavigate();
  const { devices } = useContext(RegistrationsContext);
  const { devices: deviceData, isDevicesLoading } = devices;

  const handleCreateNewRegistration = async () => {
    if (deviceData === null) {
      return;
    }
    setLoading(true);
    const pickedDevices = deviceData.filter((devices) => selectedDevices.includes(devices.serialNumber));
    let sendDevices = { devices: pickedDevices };
    const deviceIds = sendDevices.devices.map(d => d.id);
    navigate(`/new-registration/devices`, { state: { deviceIds } });
    setLoading(false);
    return;
  };

  return (
    <>
      <Grid container justifyContent="center" alignItems="center">
        <Grid item xs style={{ marginTop: '20px' }}>
          <Typography variant="h4" component="div" gutterBottom>
            {t('registrations.general.unregisteredDevices', { context: 'plural' })}
          </Typography>
        </Grid>
        <Grid item xs={1.75} justifyContent="flex-end">
          <FormButton
            color="success"
            variant="contained"
            title={t('registrations.general.addNewRegistration')}
            disabled={selectedDevices.length === 0}
            onClick={handleCreateNewRegistration}
            loading={loading}
          />
        </Grid>
      </Grid>
      {isDevicesLoading && <TableSkeleton />}
      {deviceData && deviceData.length > 0 && (
        <UnregisteredDevicesTable
          isLoading={isLoading}
          devices={deviceData!}
          selectedDevices={selectedDevices}
          setSelectedDevices={setSelectedDevices}
        />
      )}
      {deviceData && deviceData.length === 0 && !isDevicesLoading && <Typography>{t('registrations.general.noDevicesWasFound')}</Typography>}
    </>
  );
};

export default Wrapper;
